import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { CopiaContratoService } from '../services/copiacontrato.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { CopiaContrato } from '../modelo/copiaContrato';
import { CopiaContratoNewSpaceOrquestradora } from '../modelo/copiaContratoNewSpaceOrquestradora';

declare let $: any;

@Component({
  selector: 'app-copia-modal-disponivel',
  templateUrl: './copia-contrato-modal-disponivel.component.html',
  styleUrls: ['./copia-contrato.component.css'],
  providers: [CopiaContratoService, MensagemService, RestClientService]
})
export class CopiaContratoModalDisponivelComponent extends AbstractComponent implements OnInit {
  copiaContratoNew: CopiaContratoNewSpaceOrquestradora;
  copiaContrato: CopiaContrato;
  
  status: string;

  constructor(
    private sessaoService: SessaoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CopiaContratoModalDisponivelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);

    this.copiaContrato = this.data.copiaContrato;
    this.copiaContratoNew = this.data.copiaContratoNew;
    if (this.copiaContrato == null) {
      this.copiaContrato = new CopiaContrato();
    }

    if (this.copiaContratoNew == null) {
      this.copiaContratoNew = new CopiaContratoNewSpaceOrquestradora();
    }
  }

  /**
   * Método chamado quando o componente é incializado
   */
  ngOnInit() {
    this.status = this.data.contrato.cdStatusRegra;  
    setTimeout(function(){
      $('.cdk-global-overlay-wrapper').css({ 'align-items': 'flex-end' });
    }, 0);
  }

  /**
   * Efetua o download do arquivo
   */
  download() {
    const fileName = `copiaContrato_${this.copiaContrato.nuContrato}`;
    if (this.copiaContrato.dsUrlDownload) {
      const link = document.createElement('a');
      link.href = this.copiaContrato.dsUrlDownload;
      document.body.appendChild(link);
      link.click();
    } else {
      CopiaContratoService.download(fileName, this.copiaContrato.pdfBytes);
    }
    this.fechar();
  }

  downloadNew() {
    const fileName = `copiaContrato_${this.copiaContratoNew.numeroContrato}`;
    if (this.copiaContratoNew.origem == "NEWSPACE" && this.copiaContratoNew.documentsNewSpace) {
      const link = document.createElement('a');
      link.href = this.copiaContratoNew.documentsNewSpace;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
    } else if(this.copiaContratoNew.conteudoBase64 != null && this.copiaContratoNew.conteudoBase64 != "") {
      this.downloadBase64File(this.copiaContratoNew.conteudoBase64, 'application/pdf', `copiaContrato_${this.copiaContratoNew.contractCode}`)
    }
    this.fechar();
  }

  
  downloadBase64File(base64Data, contentType, filename):void {
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }




  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-copia-contrato-cli/copia-contrato-modal-disponivel.component.ts